/* eslint-disable @typescript-eslint/no-explicit-any */
import { useEffect, useState } from 'react';
import { FileCheck2 } from 'lucide-react';
import { chamarApi } from '@/nucleo/auth/cliente-api';
import { Button } from '@/ui/base/button';
const NS = '/bff/v1/j10-s04-gestor-encerrar-solicitacao';
export function EncerrarSolicitacaoPage() {
  const [e, setE] = useState<any>();
  const [ocupado, setO] = useState(false);
  async function call(path: string, corpo?: unknown) {
    setO(true);
    try {
      const r = await chamarApi<any>(NS + path, {
        metodo: path === '/state' ? 'GET' : 'POST',
        corpo,
      });
      setE(r.state);
    } finally {
      setO(false);
    }
  }
  useEffect(() => {
    void call('/state');
  }, []);
  if (!e) return <main role="status">Carregando fila…</main>;
  return (
    <main className="w-full min-w-0 space-y-5 overflow-x-hidden">
      <h1 className="text-3xl font-semibold">
        <FileCheck2 className="mr-2 inline" />
        {e.titulo}
      </h1>
      <p>{e.descricao}</p>
      {e.alertas.map((a: any) => (
        <p role="alert" key={a.codigo}>
          {a.mensagem} <code>{a.codigo}</code>
        </p>
      ))}
      {e.vazio && <p>Nenhum pedido na fila.</p>}
      {e.pedidos.map((p: any) => (
        <article className="space-y-3 rounded-md border p-4" key={p.id}>
          <h2 className="font-semibold">
            {p.protocolo} · {p.resultado_final ?? p.status}
          </h2>
          <p>
            Fila {p.fila} · versão {p.versao} · prazo{' '}
            {new Date(p.prazo_decisao_em).toLocaleString('pt-BR')}
          </p>
          <p>
            Decisão {p.decisao ?? 'ainda não registrada'} · efeito{' '}
            {p.efeito_id ? 'aplicado' : 'não aplicado'}
          </p>
          <p>
            Eventos persistidos: {p.linha_tempo.length} · notificações: {p.notificacoes.length}
          </p>
          {!p.encerramento_id && p.decisao && (
            <Button
              disabled={ocupado}
              onClick={() =>
                void call('/verbs/encerrar_pedido', {
                  solicitacaoId: p.id,
                  chaveIdempotencia: crypto.randomUUID(),
                })
              }
            >
              Encerrar pedido decidido
            </Button>
          )}
          {p.encerramento_id && ['APROVADA', 'REJEITADA'].includes(p.resultado_final) && (
            <Button
              disabled={ocupado}
              variant="outline"
              onClick={() =>
                void call('/verbs/encerrar_pedido', {
                  solicitacaoId: p.id,
                  chaveIdempotencia: p.encerramento_chave,
                })
              }
            >
              Repetir encerramento idempotente
            </Button>
          )}
          {!p.encerramento_id && !p.decisao && (
            <Button
              disabled={ocupado}
              variant="outline"
              onClick={() =>
                void call('/verbs/expirar_pedido', {
                  solicitacaoId: p.id,
                  chaveIdempotencia: crypto.randomUUID(),
                })
              }
            >
              Avaliar expiração
            </Button>
          )}
          {p.indicador && (
            <p>
              Indicador: {p.indicador.resultado} · {p.indicador.duracao_segundos}s ·{' '}
              {p.indicador.motivo_codigo}
            </p>
          )}
          <code className="break-all">{p.id}</code>
        </article>
      ))}
      {e.resultado && <p role="status">Operação persistida: {JSON.stringify(e.resultado)}</p>}
    </main>
  );
}
